<template>
    <div>
        <div
            class="d-flex justify-content-between align-items-center mb-3 flex-wrap"
        >
            <h1 class="m-0">News</h1>
            <div class="form-control uhe-search-input-wrapper d-flex my-auto">
                <i class="material-icons mr-1">search</i>

                <input
                    ref="searchInput"
                    class="uhe-search-input flex-fill"
                    type="search"
                    placeholder="Suche"
                    aria-label="Suche"
                    @input="onSearchInput"
                />
            </div>
        </div>
        <div v-for="(article, index) in articles" :key="article.id">
            <hr class="my-2 my-lg-4" v-if="index > 0"/>
            <div class="media flex-wrap">
                <a
                    :href="'/news/' + article.id"
                    class="uhe-a-none col-12 col-lg-3 align-self-center p-0"
                >
                    <img
                        v-if="article.image_id != null"
                        class="uhe-media-img w-100"
                        :src="'/storage/' + article.image.origPath"
                        :alt="'/storage/' + article.image.origPath"
                    />
                    <img
                        v-else
                        class="uhe-media-img w-100"
                        src="/img/handball_closeup_thumb.jpg"
                        alt="/img/handball_closeup_thumb.jpg"
                    />
                </a>
                <div class="media-body p-sm-3 p-1 p-lg-0 pl-lg-3">
                    <a
                        :href="'/news/' + article.id"
                        class="uhe-a-none d-flex mb-2 align-items-center flex-wrap"
                    >
                        <h5 class="my-auto mr-2">{{ article.title }}</h5>
                        <small
                            v-if="article.created_at != null"
                            class="my-auto text-muted"
                        >{{ article.locale_created_at }}</small
                        >
                    </a>
                    <div v-html="article.teaser + '...'" class="d-inline"></div>
                    <a class="uhe-link" :href="'/news/' + article.id"
                    >→ Weiterlesen</a
                    >
                </div>
            </div>
        </div>
        <paginator :data="paginatorInfo" @changePage="getArticles"></paginator>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                articles: [],
                paginatorInfo: undefined,
                timeout: undefined,
                q: undefined
            };
        },
        mounted() {
            this.getArticles();
        },
        methods: {
            getArticles(page = -1, q = "") {
                let url = "/articles";
                let searchUrl = "/search/articles";

                if (q == "" && this.q != undefined) q = this.q;

                if (page < 0) {
                    if (q != "") {
                        url = searchUrl + "?q=" + q;
                    }
                } else {
                    if (q == "") {
                        url += "?page=" + page;
                    } else {
                        url = searchUrl + "?page=" + page + "&q=" + q;
                    }
                }
                window.axios.get(url).then(({data}) => {
                    this.paginatorInfo = data;
                    this.articles = data.data;
                });
            },
            onSearchInput(e) {
                if (this.timeout == undefined) {
                    this.timeout = setTimeout(this.search, 250);
                } else {
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(this.search, 250);
                }
            },
            search(page = -1) {
                if (this.$refs.searchInput.value == "") {
                    this.q = undefined;
                    this.getArticles(page);
                } else {
                    this.q = this.$refs.searchInput.value;
                    this.getArticles(page, this.$refs.searchInput.value);
                }
            }
        }
    };
</script>

<style scoped>
</style>
